import { mapEducatorDataToRows } from "../../utils/mapEducatorDataToRows";
import { TertiaryTable } from "@hatch-digital-nl/abs-storybook/legacy";
import { getEducatorTableColumns } from "../../utils/getEducatorTableColumns";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import Skeleton from "react-loading-skeleton";
import { EducatorInterface } from "../../../../common/interfaces/EducatorInterface";
import { JSX } from "react";
import { MetaInterface } from "../../../../common/interfaces/MetaInterface";

interface Props {
    educatorData?: {
        data?: EducatorInterface[];
        meta?: MetaInterface;
    };
    educatorDataIsLoading: boolean;
    educatorDataIsFetching: boolean;
}

export const Educators = (props: Props): JSX.Element => {
    const { educatorData, educatorDataIsLoading, educatorDataIsFetching } =
        props;
    const dispatch = useAppDispatch();
    const { sortEducators } = useAppSelector(
        (state) => state.qualificationDetail,
    );

    if (!educatorData || educatorDataIsLoading || educatorDataIsFetching) {
        return <Skeleton count={6} height={"5rem"} borderRadius={"0.8rem"} />;
    }

    return (
        <TertiaryTable
            data={{
                columns: getEducatorTableColumns({
                    sortEducators,
                    dispatch: dispatch,
                }),
                rows: mapEducatorDataToRows({
                    educatorData: educatorData?.data || [],
                }),
                total: educatorData.meta?.total || 0,
            }}
            title={`Opleiders (${educatorData.meta?.total || 0})`}
            isPagination={false}
            isBackgroundTransparent={true}
            emptyResultText={"Deze kwalificatie heeft nog geen opleiders."}
            isDataEmpty={educatorData.meta?.total === 0}
        />
    );
};
